import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import BonTransfert from "../TransfertArticles/files/BonTransfert";
import { societeId } from "../../_App/Redux/Slices/Auth/authSlice";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import ReactToPrint from "react-to-print";
import { formadate } from "../../_App/Helpers/helpers";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";
import { findFileApi } from "../../_App/Redux/Slices/achat/achatSlice";
import { AxiosResponse } from "axios";

export default function ActionModel({ t, data, showModal, setshowModal }: any) {
  const dispatch = useAppDispatch();
  const societe = useAppSelector(societeId);
  const [type, settype] = useState("");
  const [showbon, setshowbon] = useState(false);
  const componentRef = useRef<any>();
  const handelgetfile = async () => {
    try {
      // Dispatch l'action pour récupérer le fichier
      const achat_file = data.data.file;
      if (achat_file && achat_file.length !== 0) {
        const action = await dispatch(findFileApi("achat_file"));

        // Vérifiez si l'action est accomplie
        if (findFileApi.fulfilled.match(action)) {
          const axiosResponse: AxiosResponse = action.payload;

          // Créez un Blob à partir de la réponse
          const blob = new Blob([axiosResponse.data], {
            type: axiosResponse.headers["content-type"],
          });

          // Créez un object URL pour le Blob
          const objectUrl = URL.createObjectURL(blob);

          // Ouvrez un nouvel onglet avec le PDF
          const newTab = window.open(objectUrl, "_blank");
          if (!newTab) {
            ToastWarning("Popup blocker prevented opening a new tab.");
          }
        } else if (findFileApi.rejected.match(action)) {
          // Gérez le cas où l'action est rejetée
          const error = action.payload;
          console.log(error);
          ToastWarning("error lors de traitement d action ");
        }
      } else {
        ToastWarning("l'achat ne contient pas de document");
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <Modal
      show={showModal}
      onHide={() => setshowModal(false)}
      className="modal-1"
      dialogClassName="modal-90w"
      backdropClassName="modal-backdrop-1"
    >
      <Modal.Header closeButton>
        <Modal.Title>{data?.type}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {data?.type === "Transfert" && (
          <>
            <div className="row">
              <div className="col-2">
                <strong>{t(" Organisation sortie")}</strong>{" "}
                {data?.data?.organisation_transfer?.nom}
              </div>
              <div className="col-2">
                <strong>{t(" Depots sortie ")}</strong>{" "}
                {data?.data?.depots_id?.libelle}
              </div>
              <div className="col-4">
                <strong>{t(" User confirmation sortie ")}</strong>{" "}
                {data?.data?.accepter_transfer?.user_id?.nom}{" "}
                {data?.data?.accepter_transfer?.user_id?.prenom}
              </div>

              <div className="col-2">
                <strong>{t(" Agent Livraison")}</strong>{" "}
                {data?.data?.agentLivraison?.nom}
              </div>
              <div className="col-2 mt-2">
                <strong>{t(" Organisation entrée")}</strong>{" "}
                {data?.data?.organisation_demande?.nom}
              </div>
              <div className="col-2 mt-2">
                <strong>{t(" Depots entrée ")}</strong>{" "}
                {data?.data?.depots_reception?.libelle}
              </div>
              <div className="col-4 mt-2">
                <strong>{t(" User confirmation reception ")}</strong>{" "}
                {data?.data?.approver_reception?.user_id?.nom}{" "}
                {data?.data?.approver_reception?.user_id?.prenom}
              </div>

              <div className="col-2 mt-2">
                <button
                  className="btn c-primary"
                  onClick={() => {
                    settype("transfert");
                    setshowbon(true);
                  }}
                >
                  {t(" Bon Transfert ")}
                </button>
              </div>
              <div className="col-2 mt-2">
                <button
                  className="btn c-primary"
                  onClick={() => {
                    settype("reception");
                    setshowbon(true);
                  }}
                >
                  {" "}
                  {t(" Bon Reception ")}
                </button>
              </div>
            </div>
            {showbon && (
              <BonTransfert
                societeid={societe}
                datainfo={data.data}
                t={t}
                type={type}
                ShowBon={showbon}
                setshowbon={setshowbon}
              />
            )}
          </>
        )}
        {data?.type === "Reservation" && (
          <div className="row">
            <div className="col-2">
              <strong>{t(" Organisation")}</strong>{" "}
              {data?.data?.organisation_id?.nom}
            </div>
            <div className="col-2">
              <strong>{t(" Depots")}</strong> {data?.data?.depots_id?.libelle}
            </div>
            <div className="col-2">
              <strong>
                {" "}
                {data?.data?.infoclient?.client?.defaultClient
                  ? "client passagé"
                  : "Client"}
              </strong>{" "}
            </div>
            <div className="col-2">
              <strong>{t("Nom Client")}</strong> {data?.data?.infoclient?.nom}
            </div>
            <div className="col-2">
              <strong>{t(" Client Num telephone")}</strong>{" "}
              {data?.data?.infoclient?.mobile}
            </div>
            <div className="col-2">
              <strong>{t(" Commande")}</strong>{" "}
              {data?.data?.code_commande?.order_number}
            </div>
            <div className="col-2">
              <strong>{t(" Total")}</strong>{" "}
              {data?.data?.code_commande?.totalNet?.toFixed(3)}
            </div>
            <div className="col-2">
              <strong>{t(" Avance")}</strong>{" "}
              {data?.data?.avance
                ?.reduce((sum:any, item:any) => sum + (item.total || 0), 0)
                .toFixed(3)}
            </div>
            <div className="col-2">
              <strong>{t(" Date")}</strong> {data?.data?.date?.split("T")[0]}
            </div>
            <div className="col-2">
              <strong>{t(" Date echeance")}</strong>{" "}
              {data?.data?.date_echeance.split("T")[0]}
            </div>
            <div className="col-2">
              {data?.data?.payer ? "Payé" : "non payé"}
            </div>
          </div>
        )}

        {data?.type === "BonSortie" && (
          <>
            <div className="mt-5" ref={componentRef}>
              <div className="row mb-3 ">
                <strong className="col-3">
                  {t("Code Reception")} :{" "}
                  {data.data.reception_id?.code_reception}
                </strong>
                <strong className="col-3">
                  {t("Organisation")} :{" "}
                  {data.data.reception_id?.organisation_id?.nom}
                </strong>
                <strong className="col-3">
                  {t("Depot")} : {data.data.reception_id?.depot_id?.libelle}
                </strong>
                <strong className="col-3">
                  {t("Utilisateur")} :{" "}
                  {data.data.reception_id?.updatedBy?.nom +
                    " " +
                    data.data.reception_id?.updatedBy?.prenom}
                </strong>
              </div>
              <div className="row">
                <div className="col-4">
                  <strong>
                    {t("Article parent")}:
                    {data?.data?.ligne_reception_id?.code_article}
                  </strong>
                </div>

                <div className="col-4">
                  <strong>
                    {t("Famille")}:
                    {
                      data?.data?.ligne_reception_id?.sous_categorie?.libelle
                        ?.fr
                    }
                  </strong>
                </div>
              </div>
              <table className="table table-bordered">
                <thead className="table-primary">
                  <tr>
                    <th>{t("Code Article")}</th>
                    <th>{t("Article")}</th>
                    <th>{t("Quantité")}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{data.data.article?.code_article}</td>
                    <td>{data.data.article?.titre?.fr}</td>
                    <td>{data.data.Quantite}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ReactToPrint
              trigger={() => <button className="btn btn-primary">Print</button>}
              content={() => componentRef.current}
            />
          </>
        )}



        {data?.type === "achat" && (
          <>
            <div className="mt-5" ref={componentRef}>
              <div className="container mt-4 ">
                <div className="row mb-3 ">
                  <div className="col-md-2 ">
                    <div className="form-group equal-height">
                      <div className="row mb-2">
                        <label htmlFor="reference_document">
                          {t("Ref-Document")}
                        </label>
                        <span>{data.data.reference_document}</span>
                      </div>

                      <div className="row mb-2">
                        <label htmlFor="fournisseur_id ">
                          {t("Fournisseur")}
                        </label>
                        <span> {data.data.fournisseur?.libelle}</span>
                      </div>
                      <div className="row mb-2">
                        <label htmlFor="fournisseur_id ">
                          {t("Organisation")}
                        </label>
                        <span> {data.data.organisation_id?.nom}</span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-2 ml-2 ">
                    <div className="form-group equal-height">
                      <div className="row mb-2">
                        <label htmlFor="date_document">
                          {t("date document")}
                        </label>
                        <span>{formadate(data.data.date_document)}</span>{" "}
                      </div>
                      <div className="row mb-2">
                        {" "}
                        <label htmlFor="date_livraison">
                          {t("date livraison")}
                        </label>
                        <span> {formadate(data.data.date_livraison)}</span>
                      </div>
                      <div className="row mn-2">
                        {" "}
                        <label>{t("depots")}</label>
                        <span> {data.data.depots_id?.libelle}</span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-1 ">
                    <div className="form-group equal-height">
                      <div className="row mb-2">
                        {" "}
                        <label htmlFor="RPied">{t("R.Pied")}</label>
                      </div>

                      <div className="row mb-2">
                        {" "}
                        <label htmlFor="REspece">{t("R.Espece")}</label>
                      </div>

                      <div className="row">
                        {" "}
                        <label htmlFor="RFacture">{t("R.Facture")}</label>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-1  ml-5">
                    <div className="form-group equal-height">
                      <div className="row mb-2">{data.data.RPied}</div>
                      <div className="row mb-2">{data.data.REspece}</div>
                      <div className="row mb-2">{data.data.RFacture}</div>
                    </div>
                  </div>

                  <div className="col-md-2 ">
                    <div className="form-group equal-height">
                      <label>
                        {t("Total HT : ")}
                        <span>{data.data.total_ht?.toFixed(3)}</span>
                      </label>

                      <label>
                        {t("Total TTC :")}
                        <span>{data.data.total_ttc?.toFixed(3)}</span>
                      </label>

                      <label>
                        {t("Total Net TTC :")}{" "}
                        <span>{data.data?.total_net_ttc?.toFixed(3)}</span>
                      </label>

                      <label>
                        {t("timber :")} <span>{data.data?.timber}</span>
                      </label>

                      <label>
                        {t("Total a payer : ")}
                        <span>{data.data?.total_net_payer?.toFixed(3)}</span>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group ">
                      <label htmlFor="commentaire">{t("commentaire")}</label>
                      {data.data.commentaire}
                    </div>
                    <label>
                      <i className="fas fa-file-alt fa-lg"></i>{" "}
                      <p>{t("Voir le document d'achat")}</p>
                    </label>
                  </div>
                </div>
              </div>
              <div className="container mt-4">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>{t("Produit")}</th>
                        <th>{t("Depots")}</th>
                        <th>{t("Code a barre Produit")}</th>
                        <th>{t("Quantite")}</th>
                        <th>{t("Prix Achat TTC")}</th>
                        <th>{t("Prix Achat HT")}</th>
                        <th>{t("Remise")}</th>
                        <th>{t("Total Net Achat TTC")}</th>
                        <th>{t("Total Prix Achat TTC")}</th>
                        <th>{t("Total Prix Achat HT")}</th>

                        <th>{t("TVA")}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.data?.lignes?.map((item: any, index: number) => (
                        <tr key={index}>
                          <td>
                            {" "}
                            <span>
                              {item?.produit?.titre?.fr
                                ? item.produit?.titre.fr
                                : ""}
                            </span>
                          </td>
                          <td>{item?.depots_id?.libelle}</td>
                          <td> {item?.produit?.code_a_barreProduit}</td>
                          <td>{item?.quantite}</td>
                          <td>{item?.prix_ttc?.toFixed(3)}</td>
                          <td>{item?.prix_ht?.toFixed(3)}</td>
                          <td>{item?.remise}</td>
                          <td>{item?.total_net_ttc?.toFixed(3)}</td>
                          <td>{item?.total_prix_ttc?.toFixed(3)}</td>
                          <td>{item?.total_prix_ht?.toFixed(3)}</td>
                          <td>{item?.tva}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}
